import { render, staticRenderFns } from "./GatewayManagement.vue?vue&type=template&id=20686e7b&scoped=true"
import script from "./GatewayManagement.vue?vue&type=script&lang=js"
export * from "./GatewayManagement.vue?vue&type=script&lang=js"
import style0 from "./GatewayManagement.vue?vue&type=style&index=0&id=20686e7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20686e7b",
  null
  
)

export default component.exports